package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val EfficacyCardStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.nearBackground)
            .borderRadius(12.px)
            .padding(32.px)
            .transition(
                Transition.of("transform", 0.3.s), 
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .translateY((-5).px)
            .boxShadow(0.px, 12.px, 24.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
    }
}